/*
 * Filename: cq-app-store.ts
 * Description: his file act as a top level store to store model dependencies.It is a root store for mobx-state-tree.
 */

import { types } from 'mobx-state-tree';
import { OutputConfig } from './models/config-output.model';
import { FieldDetails } from './models/field-details.model';
import { FieldRulesObject } from './models/field-rule-object.model';
import { FieldPickListData } from './models/field-picklistValueSource.model';
import { FieldDynamicSourceData } from './models/field-dynamicValueSource.model';
import { FormulaFieldData } from './models/formula-field.model';
import { RulesElementsObject } from './models/rule-elements.model';
import { UtilityObject } from './models/utility.model';
import { FieldUIType } from './models/field-uiType.model';
import { GridObject } from './models/grid-object.model';

/** 
* @description Master Data Store Model Initialize
*/

export const CQMasterDataModel = types.model({
    OutputConfig,
    Details: FieldDetails,
    RulesObject: FieldRulesObject,
    PicklistValueSource: FieldPickListData,
    UITypeSource: FieldUIType,
    DynamicSourceValue: FieldDynamicSourceData,
    FormulaField: FormulaFieldData,
    RuleElements: RulesElementsObject,
    UtilityObject,
    GridObject
});

/** 
 * @description App Store Creation
 */
export const CQMasterDataStore = CQMasterDataModel.create({
    OutputConfig:
    {
        cqEsig: {},
        cqEsigAction: {},
        cqForm: {},
        cqGridGenerator: {},
        cqNBA: {},
        cqTemplate: {}
    },
    Details: {
        selectedFieldDetailsObject: {},
        fields: {},

    },
    RulesObject: {
        FieldRuleObject: {},
        FieldRuleElement: {}
    },
    PicklistValueSource: {
        FieldPickListData: {},
        selectedPicklistValue: {}
    },
    UITypeSource: {
        FieldUIType: {},
        selectUITypeValue: {}
    },
    DynamicSourceValue: {
        FieldDynamicSourceData: {},
        selectedDynamicSourceValue: {}
    },
    FormulaField: {
        FormulaFieldData: {},
        selectedFormulaFieldValue: {}
    },
    RuleElements: {
        FieldRuleElement: {}
    },
    UtilityObject: {
        componentTabState: true
    },
    GridObject: {
        gridComponentConfigView: {},
        selectedHeaderAction: '',
        headerActions: {},
        selectedRowAction: '',
        customActionObject: {}
    }
});

export type CQMasterDataStore = typeof CQMasterDataModel.Type;
